import { insightsReportsWizardSlice } from './insightsReportsWizardSlice';

export const { setSelectedInsightsReportType, resetInsightsReportsWizardState } = insightsReportsWizardSlice.actions;
